export const flatten = function (data) {
  var result = {};
  function recurse(cur, prop) {
    if (Object(cur) !== cur) {
      result[prop] = cur;
    } else if (Array.isArray(cur)) {
      for (var i = 0, l = cur.length; i < l; i++)
        recurse(cur[i], prop + "[" + i + "]");
      if (l === 0) result[prop] = [];
    } else {
      var isEmpty = true;
      for (var p in cur) {
        isEmpty = false;
        recurse(cur[p], prop ? prop + "." + p : p);
      }
      if (isEmpty && prop) result[prop] = {};
    }
  }
  recurse(data, "");
  return result;
};
export function parseStringTemplate(str, obj) {
  const arrS = str.split("{{").map((s, i) => {
		const varSplit = s.split("}}")
    if (varSplit.length === 2) {
			const key = varSplit[0].split("||")[0].trim()
			let defaultValue = varSplit[0].split("||")[1];
			defaultValue = defaultValue && defaultValue.length >1 && defaultValue[0] === " " ? defaultValue.slice(1) : ""; // based on the value we have to decide "" or " "
			//resolve variable
			const placeholderValue = (obj[key] && typeof obj[key] === 'string' && obj[key] !== "") // to check to obj[key] case
			? obj[key]
			:( obj[key] && typeof obj[key] === 'object' && obj[key]?.value !== null && obj[key]?.value !== undefined && obj[key]?.value !== "" ) ?obj[key]?.value : defaultValue

			return [placeholderValue, varSplit[1]].join("")
		}
		return s
	})
  return arrS.join("");
}

export const TemplateVariables = {
  contact: {
    phone: "8888888888",
    firstname: "John",
    lastname: "Snow",
    hs_object_id: "007",
  },
  companies: {
    city: "Cambridge",
    domain: "biglytics.net",
    industry: "Technology",
    name: "Biglytics",
    phone: "(877) 929-0687",
    state: "Massachusetts",
    createdate: "2019-10-30T03:30:17.883Z",
    hs_lastmodifieddate: "2019-12-07T16:50:06.678Z",
  },
  deals: {
    amount: "1500.00",
    dealname: "Custom data integrations",
    dealstage: "presentation scheduled",
    hubspot_owner_id: "910901",
    pipeline: "default",
    closedate: "2019-12-07T16:50:06.678Z",
    createdate: "2019-10-30T03:30:17.883Z",
    hs_lastmodifieddate: "2019-12-07T16:50:06.678Z",
  },
};

export const validateYup = (schema, formObj) => {
  return new Promise((resolve, reject) => {
    schema
      .validate(formObj, {
        abortEarly: false,
      })
      .catch((err) => {
        console.dir(err);
        let errors = {};
        err.inner.forEach((e) => {
          console.log(e.message, e.path);
          errors[e.path] = { message: e.message };
        });
        reject(errors);
      })
      .then(resolve);
  });
};
